import { useContext, useState } from "react";

import Axios from "axios";
import { Button, Modal } from "react-bootstrap";
import { toast } from "react-toastify";

import DashboardContext from "../../Context";

import style from "./ModalDelete.module.css";

const ModalConfirmCancelJobDispatch = ({
  isShow,
  handleCloseModal,
  submit,
  cancelWithPenalty,
  workerName
}) => {

  const [loading, setLoading] = useState(false);

  const [dataDelete, setDataDelete] = useState({});

  return (
    <Modal show={isShow}>
      <Modal.Header >
        <Modal.Title> لغو کار - {workerName}</Modal.Title>
        <i
          className="fa fa-times mr-auto"
          style={{ fontSize: "16px", cursor: "pointer" }}
          onClick={handleCloseModal}
          aria-hidden="true"
        ></i>
      </Modal.Header>
      <Modal.Body className={style.body}>
        <p style={{color:'red',fontSize:20,fontWeight:'bold'}}> {cancelWithPenalty ? "لغو همراه جریمه و امتیاز منفی" : ""}</p>
        <i className="mdi mdi-alert-circle-outline"></i>
        {loading
          ? "درحال لغو منتظر باشید..."
          : dataDelete.hasOwnProperty("statusCode")
            ? dataDelete.message
            : "آیا از لغو مطمئن هستید؟"}
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="danger"
          className="ml-auto"
          disabled={loading}
          onClick={handleCloseModal}
        >
          خیر
        </Button>
        <Button variant="success" disabled={loading} onClick={submit}>
          {loading ? <i className="fa fa-spinner fa-pulse fa-fw"></i> : "بله"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalConfirmCancelJobDispatch;
